import React, { useState } from 'react';

const TermsModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="hover:text-orange-400 transition"
      >
        Terms & Conditions
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="relative bg-white w-full max-w-3xl h-[80vh] rounded shadow-lg overflow-hidden flex flex-col">
            {/* Close Button */}
            <div className="flex justify-end p-2 bg-gray-100">
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-700 hover:text-red-600 text-2xl leading-none"
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            {/* Iframe Content */}
            <iframe
              src={`${process.env.REACT_APP_BASE_URL}/terms-condition.html`}
              title="Terms and Conditions"
              className="flex-1 w-full border-none"
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default TermsModal;
